module.exports = __webpack_public_path__ + "static/media/comment-alt-plus.ca098181.svg";